import React, { useEffect, useState } from "react"

import { css } from "@emotion/react"
import Prism from "prismjs"
import "prismjs/themes/prism-tomorrow.css"
import { useClipboard } from "use-clipboard-copy"

import { NIRVANA_COLORS } from "../config/theme.config"
import { ButtonElement } from "./button.element"
import { PrimaryText } from "./primaryText.element"

export const CodeCopyBlockElement: React.FunctionComponent<
    ICodeCopyBlockElementProps
> = props => {
    const clipboard = useClipboard()
    const [isCodeCopied, setIsCodeCopied] = useState<boolean>(false)

    useEffect(() => {
        Prism.highlightAll()
    }, [])

    useEffect(() => {
        setIsCodeCopied(clipboard.copied)
    }, [clipboard.copied])

    // On code copied show and hide message that it was copied
    useEffect(() => {
        if (!isCodeCopied) {
            return
        }

        const timeoutId = setTimeout(() => {
            setIsCodeCopied(false)
        }, 5 * 1000)

        return () => {
            try {
                clearTimeout(timeoutId)
            } catch (e) {}
        }
    }, [isCodeCopied])

    return (
        <div
            css={[styles.container]}
            className={`
                relative
                ${props.className}
            `}
        >
            <pre css={styles.preWrapper}>
                <code
                    className={`language-${props.language}`}
                    css={styles.codeBlock}
                >
                    {props.code}
                </code>
            </pre>

            {/*COPY btn*/}
            <div css={styles.copyBtnContainer}>
                <ButtonElement
                    label="&nbsp; Copy &nbsp;"
                    type="primary"
                    size="middle"
                    htmlType="button"
                    onClick={() => {
                        clipboard.copy(props.code)
                    }}
                />
            </div>

            {isCodeCopied ? (
                <div css={styles.wasCopiedContainer}>
                    <PrimaryText
                        typography="caption"
                        color={NIRVANA_COLORS.brand.white}
                    >
                        Code was copied to clipboard
                    </PrimaryText>
                </div>
            ) : null}
        </div>
    )
}

const styles = {
    container: css({
        overflow: "hidden",
        borderRadius: 8,
        border: `1px solid ${NIRVANA_COLORS.brand.warmShadow}`,
    }),
    copyBtnContainer: css({
        position: "absolute",
        right: 5,
        bottom: 10,
    }),
    wasCopiedContainer: css({
        width: "100%",
        position: "absolute",
        bottom: 10,
        left: 0,
        paddingTop: 8,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        backgroundColor: NIRVANA_COLORS.brand.primary,
        color: "white",
    }),
    preWrapper: css({
        backgroundColor: NIRVANA_COLORS.brand.whitePurple,
        padding: 16,
    }),
    codeBlock: css({
        color: NIRVANA_COLORS.brand.primary,
    }),
}

interface ICodeCopyBlockElementProps {
    className?: string
    language: "html" | "text" | "javascript"
    code: string
}
